module.exports = __webpack_public_path__ + "img/box6-27.2a32ea02.png";